import GameStream from "../GameStream";
import { MockStream } from "./MockStream";
import { MockMeta } from "./MockMeta";

export class MockGameStream implements GameStream {
  public stream: MockStream;
  public meta: MockMeta;
  constructor() {
    this.stream = new MockStream();
    this.meta = new MockMeta();
  }
}
